import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { baseUrl } from "../../Utility/constants";
import Footer from "../common/Footer";
import "./StudentPersonalDetails.css";
import TeacherHeader from "../common/TeacherHeader";
import { Table, Button } from "react-bootstrap";

const NumbermappingMaster = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  // Fetch students by teacher
  const fetchData = async () => {
    try {
      const url = `${baseUrl}/api/PersonalDetails/PersonalDetailsByTeacherId?TeacherId=${localStorage.getItem(
        "userID"
      )}`;
      const response = await axios.get(url);
      if (response?.data) {
        setData(response.data);
      }
    } catch (error) {
      console.error("Error fetching data", error);
      toast.error("Failed to load student details.");
    }
  };

  // Handle field changes
  const handleChange = (index, field, value) => {
    const updatedData = [...data];
    updatedData[index][field] = value;
    setData(updatedData);
  };

  // Save all records
  const handleSave = async () => {
    try {      
      // Build payload with only necessary fields
      const payload = data.map((item) => ({
        studentId: item.studentId,
        rollNo: item.rollNo,
        generalRegisterNo: item.generalRegisterNo,
        examSeatNo: item.examSeatNo,
        updatedBy: Number(localStorage.getItem("userID"))
      }));

      await axios.put(`${baseUrl}/api/Teachers/UpdateNumbersBulk`, payload);

      toast.success("Student numbers saved successfully!");
      fetchData();
    } catch (error) {
      console.error("Error saving details", error);
      toast.error("Failed to save details.");
    }
  };

  return (
    <>
      <TeacherHeader />

      <div className="container mt-5 mb-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2>Welcome to Teacher's Panel</h2>
          <Button variant="primary" onClick={handleSave}>
            Save All
          </Button>
        </div>

        <Table striped bordered hover responsive>
          <thead className="thead-dark">
            <tr>
              <th>#</th>
              <th>Student Name</th>
              <th>GR No</th>
              <th>Roll No</th>              
              <th>Exam Seat No</th>
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((item, index) => (
                <tr key={item.studentId}>
                  <td>{index + 1}</td>
                  <td>{`${item.firstName} ${item.middleName || ""} ${item.lastName || ""}`.trim()}</td>
                  <td>
                    <input
                      type="text"
                      value={item.generalRegisterNo || ""}
                      placeholder="Enter GR No"
                      onChange={(e) =>
                        handleChange(index, "generalRegisterNo", e.target.value)
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={item.rollNo || ""}
                      placeholder="Enter Roll No"
                      onChange={(e) => handleChange(index, "rollNo", e.target.value)}
                    />
                  </td>                  
                  <td>
                    <input
                      type="text"
                      value={item.examSeatNo || ""}
                      placeholder="Enter Exam Seat No"
                      onChange={(e) => handleChange(index, "examSeatNo", e.target.value)}
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center">
                  No records found.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <Footer />
      <ToastContainer />
    </>
  );
};

export default NumbermappingMaster;
